import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import WorkIcon from '@mui/icons-material/Work';

const JobExperienceList = ({ jobExperiences, onEdit, onDelete, compact = false }) => {
    if (!jobExperiences || jobExperiences.length === 0) {
        return (
            <Typography color="textSecondary" className="text-center py-4">
                No job experiences added yet
            </Typography>
        );
    }

    if (compact) {
        return (
            <Box>
                {jobExperiences.map((exp) => (
                    <Box
                        key={exp.id}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-start"
                        sx={{ py: 1, borderBottom: '1px solid', borderColor: 'divider' }}
                    >
                        <Box sx={{ minWidth: 0, pr: 1 }}>
                            <Box display="flex" alignItems="center" gap={0.75}>
                                <WorkIcon color="primary" sx={{ fontSize: 18, flexShrink: 0 }} />
                                <Typography variant="body2" fontWeight={600}>
                                    {exp.title}
                                </Typography>
                            </Box>
                            {exp.company_title && (
                                <Typography variant="caption" color="text.secondary" display="block">
                                    {exp.company_title}
                                </Typography>
                            )}
                            <Typography variant="caption" color="text.secondary" display="block">
                                {exp.start_date ? new Date(exp.start_date).toLocaleDateString() : ''} –{' '}
                                {exp.end_date ? new Date(exp.end_date).toLocaleDateString() : 'Present'}
                            </Typography>
                            {exp.description && (
                                <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                                    {exp.description}
                                </Typography>
                            )}
                        </Box>
                        {(onEdit || onDelete) && (
                            <Box sx={{ flexShrink: 0 }}>
                                {onEdit && (
                                    <IconButton size="small" onClick={() => onEdit(exp)} sx={{ mr: 0.5 }}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                )}
                                {onDelete && (
                                    <IconButton size="small" color="error" onClick={() => onDelete(exp)}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box>
            {jobExperiences.map(exp => (
                <Box 
                    key={exp.id}
                    className="mb-4 p-3 border rounded"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="flex-start"
                >
                    <Box>
                        <Box display="flex" alignItems="center">
                            <WorkIcon color="primary" className="mr-2" />
                            <Typography variant="subtitle1" className="font-semibold">
                                {exp.title}
                            </Typography>
                        </Box>
                        <Typography variant="body2" color="textSecondary">
                            {exp.company_title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {new Date(exp.start_date).toLocaleDateString()} - {exp.end_date ? new Date(exp.end_date).toLocaleDateString() : 'Present'}
                        </Typography>
                        {exp.description && (
                            <Typography variant="body2" className="mt-1">
                                {exp.description}
                            </Typography>
                        )}
                    </Box>
                    
                    {(onEdit || onDelete) && (
                        <Box>
                            {onEdit && (
                                <IconButton 
                                    size="small" 
                                    onClick={() => onEdit(exp)}
                                    className="mr-1"
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            )}
                            {onDelete && (
                                <IconButton 
                                    size="small" 
                                    color="error"
                                    onClick={() => onDelete(exp)}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            )}
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
};

export default JobExperienceList; 